import React from 'react';
import CharityLogo from './CharityLogo';
import classNames from 'classnames';
import { Button as ButtonFont, HeadingSBold, BodyMBold } from 'components/Typography/Typography';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import Favorite from '@material-ui/icons/Favorite';
import styles from 'assets/jss/material-dashboard-pro-react/views/topup/donate';
import makeStyles from '@material-ui/core/styles/makeStyles';

import { translate } from 'components/Translation';

interface ThankYouProps {
	selectedDonation: types.payment.IDonation;
}

// @ts-ignore
const useStyles = makeStyles(styles);

const ThankYou = (props: ThankYouProps) => {
	const { selectedDonation } = props;

	const classes = useStyles();

	const iconClasses = classNames(classes.iconWrapper, classes.redIcon);
	return (
		<div>
			<div className={classes.thankYouContainer}>
				<div
					className={classes.thankYouContent}
					style={{ backgroundColor: selectedDonation.charity.background }}
				>
					<CharityLogo url={selectedDonation.charity.logo} size="sm" />
					<div className={classes.charityNameWrapper}>
						<BodyMBold disableMargin color="primary-dark">
							{selectedDonation.charity.name}
						</BodyMBold>
					</div>
					<div className={classes.thankYouValue}>
						<HeadingSBold disableMargin color="primary-dark">
							{translate('price', String(selectedDonation!.value))}
						</HeadingSBold>
					</div>
				</div>

				<Card className={classNames(classes.exposedCard, classes.thankYouCard)}>
					<CardBody gradient={'donate'} className={classes.exposedCardBody}>
						<div className={classes.exposedCardTitle}>
							<ButtonFont color={'primary-dark'} disableMargin>
								{translate('donations.thank.you')}
							</ButtonFont>
						</div>
						<div className={iconClasses}>
							<Favorite />
						</div>
					</CardBody>
				</Card>
			</div>
		</div>
	);
};

export default ThankYou;
